export function formatConstraintValue(type, value) {
    switch (type) {
        case 'area':
            // Ceil function rounds the decimal value to the next highest whole number, i.e. received 10.2 -> returned 11
            // Min function ensures the value doesn't go above 100, i.e. received 125 -> returned 100
            return value ? `${Math.min(Math.ceil(value), 100)}%` : '0%';
        case 'distance':
            return value
                ? `${(value / 1000).toLocaleString(undefined, { maximumFractionDigits: 2 })}km`
                : '0km';
        case 'count':
            return value;
        default:
            return '';
    }
}
